import { render } from "./VsRatioMobile.vue?vue&type=template&id=747759c2"
import script from "./VsRatioMobile.vue?vue&type=script&lang=js"
export * from "./VsRatioMobile.vue?vue&type=script&lang=js"

import "./VsRatioMobile.vue?vue&type=style&index=0&id=747759c2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__